 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"b56eed1b6270e19c0ef4","1":"6b963c57bf6a0fbf7112","2":"11c6d58f1236da263b4f","3":"9ee5376152bb52225c20","4":"bb9bf6ee88163ba35f31","5":"1c9642c62ccb475d3116","6":"54a5cf19dd41ad65ef6f","7":"113a9f431f7e07d0bdd4","vendors~Comment~ShareComment":"b7d429576f8130a84dc3","vendors~Comment~Survey":"b39aeffeafd7900a37d4","vendors~Comment":"324468ea38061335d366","Comment":"4aac6c6e99aed38b6c51","AccountOpening":"4930d088d17e3fb61b2b","BackTopBottom":"4501680cfb1d52778c66","CallupVideoAppHead":"35695ee1b90ade750ff4","Caption":"21df91ae15b79b76c9c1","Copyright":"f6470f8deb2933c040bc","DataBox":"4392cc7cb332339af124","HomeFooter":"5bd696ceda687fcf2a72","Hongbao":"7a71086f4954407aeda2","Img":"762e6d79ae40bcfac601","LivePlayer":"ceb27dd08aef4c8a273e","LoginDialog":"8cfb1a54da1b5201067b","MoreTabs":"69fec3b161ff0ae18636","Nav":"f4c09f12f2d876126298","NormalCaption":"cf14bd1c4b7d5e7391e5","Offline":"aa97ffe9c4ae809025e3","QQShare":"66ac08674a1967e47ebe","Tip":"b88a6e137af0f9c8cf63","ViewMoreLink":"f2dd1139b354a7d82e67","WxLaunchApp":"f1fffbf42d665d52f69d","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"161a616605042d0f2fc1","Atlas":"586bacf9619bd6e744a0","FiveNavPic":"bd8644de5872d855f27c","FourNavPic":"14b2fa1dec0c882d8b67","ThreeNavPic":"c165d9afd1505d0c1184","vendors~BigImage~NewsStream~NoImage~OneImage~Stick~ThreeImage~TwoImage":"872484005eb97e4c9e5f","BigImage":"2a1d34e640d77d500fc1","NoImage":"9f0ada7b5be35e6a0cff","OneImage":"0e23fc320767a32f205e","Stick":"4b5174169a5612d37ba6","TwoImage":"ad69eba5b254ddf07089","vendors~NewsStream~ThreeImage":"05695473415a9273a93d","vendors~NewsStream":"5849cf49c1e886a0cb71","vendors~BigImg~BigTopic~BottomSlides~BrowserGuideLayer~CallupHead~IndexSlides~InformationFlow~MarkTa~28c80f44":"72dcbf4d1c96eaa62386","vendors~Player":"0cecb2b62b271d1af242","Player":"58461c5fe35d85eadcb2","BrowserGuideLayer":"b73feca45b46579ea153","CallupHead":"0a0b665ede754554fb05","MarkTabs":"91bf04922cd867ca6a80","PageBottomBrand":"444952acb59cecdc5ab7","WXGuideLayer":"bb3434dee9b9d1f553c8","MdBanner":"d2f5437729d8d5477c9c","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"01fdc570cd2f687be631","SingleTitle":"055c54b34e6292afa8a6","TwoImg":"1eee4ed4e9b2a009ea17","InformationFlow":"228f07b728054bfd2697","vendors~BigImg":"641ff7d3a61a33a6df59","BigImg":"b6878435d8835dba84b0","vendors~BigTopic~TitleImg":"3b33c2ccf462210faad8","BigTopic":"393ea1a5b8a5f1830569","TitleImg":"3ef6225b6c2326c3eeb0","vendors~SlideImg":"426f811e613d844bbfdc","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"b75ae7e761bb1d74b20f","BottomSlides":"144c70ce501a99808fb7","IndexSlides":"46bf19d26425f3e1b108","vendors~UpgradeBottomSlides":"b3915feedb9f2a7fb4e1","vendors~ShareComment":"1726db4553f7a78423b6","vendors~Survey":"e28adb90f7d76f34784c","NormalSlides":"bcb0a3e543870c881e7a","ShareSlides":"91ebf4aeea0f0c1b3326","Slides":"9c708de76a58f4ad4243","vendors~NormalTabs":"2f044e53b0c9d3fe971b","vendors~SimpleGuideLayer":"d5088b514b3d93f72bc8","vendors~SlidesTabs":"d93aa58600ece37c2015","vendors~pics":"6948e9b02151f129b1fb","pics":"e41d0728446f943a725e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/channel/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
